import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TAppUpdatesDTO, TUserActionForAppUpdate } from '@monorepo/types';

@Component({
  selector: 'monorepo-app-updates',
  templateUrl: './app-updates.component.html',
  styleUrls: ['./app-updates.component.scss'],
})
export class AppUpdatesComponent implements OnInit {
  @Input() appUpdatesDTO!: TAppUpdatesDTO;
  updateNowData: TUserActionForAppUpdate = 'UPDATE_NOW';
  updateLaterData: TUserActionForAppUpdate = 'UPDATE_LATER';
  constructor(private modalCtrl: ModalController) {}

  ngOnInit(): void {}

  updateNow() {
    this.modalCtrl.dismiss(this.updateNowData);
  }

  updateLater() {
    this.modalCtrl.dismiss(this.updateLaterData);
  }
}
